import React from "react";
import PropTypes from "prop-types";
import StoryCardWidget from "../../../../../atoms/related-story-widget-card";
import styles from "./styles.m.css";
import { get } from "lodash";
import { Link } from "@quintype/components";
import Icon from "../../../../../atoms/icon";
import Carousel from "../../../../../atoms/carousel";

const RelatedStoryWidget = ({
  collection,
  className = "",
  numberOfCardsInViewDesktop = 2,
  numberOfCardsInViewTablet = 2,
  numberOfCardsInViewMobile = 1
}) => {
  const story = get(collection, ["trending"], []);
  if (!story) {
    return null;
  }
  const sectionUrl = get(story, ["0", "item", "sections", 0, "section-url"], null);
  const stories = story && story !== undefined ? story.map(item => item) : [];
  const desktopGap = 30;
  const mobileGap = 10;
  const slides =
    story &&
    story !== undefined &&
    story.map(({ item }) => (
      <StoryCardWidget key={item.id} story={item} className={`${styles["card-div"]} ${styles.card}`} />
    ));
  return stories.length ? (
    <div className={styles["stories-wrapper"]}>
      <div className={`${styles.base} ${className}`}>
        {collection.name && <h4 className={`${styles.headline}`}>{collection.name}</h4>}
        <div className={styles["stories-container"]}>
          <Carousel
            className={`${styles["first-slider"]} ${className}`}
            options={{
              type: "slider",
              perView: numberOfCardsInViewDesktop,
              gap: 10,
              focusAt: 0,
              bound: true,
              peek: {
                before: 0,
                after: 120
              },
              breakpoints: {
                320: {
                  perView: numberOfCardsInViewMobile,
                  gap: mobileGap,
                  bound: true
                },
                767: {
                  perView: numberOfCardsInViewMobile,
                  gap: mobileGap,
                  bound: true
                },
                991: {
                  perView: numberOfCardsInViewTablet,
                  gap: desktopGap,
                  bound: true,
                  peek: {
                    before: desktopGap,
                    after: 244
                  }
                }
              }
            }}
            renderCenterLeftControls={({ previousSlide, currentSlide }) =>
              currentSlide > 0 ? (
                <button
                  aria-label="previous slide"
                  role="button"
                  onClick={previousSlide}
                  className={`${styles["slider-nav-button"]} ${styles["slider-control-centerleft"]}`}
                >
                  <Icon type="angle-left" className={styles.icon} />
                </button>
              ) : null
            }
            renderCenterRightControls={({ nextSlide }) => (
              <button
                aria-label="next slide"
                role="button"
                onClick={nextSlide}
                className={`${styles["slider-nav-button"]} ${styles["slider-control-centerright"]}`}
              >
                <Icon type="angle-right" className={styles.icon} />
              </button>
            )}
          >
            {slides}
          </Carousel>
        </div>
        <Link className={styles["readmore-wrapper"]} href={`${sectionUrl}?pfrom=inarticle-section`}>
          <span className={styles["readmore"]}>மேலும் கட்டுரைகளுக்கு...</span>
        </Link>
      </div>
    </div>
  ) : null;
};

RelatedStoryWidget.propTypes = {
  className: PropTypes.string,
  collection: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    items: PropTypes.array
  }),
  numberOfCardsInViewDesktop: PropTypes.number,
  numberOfCardsInViewTablet: PropTypes.number,
  numberOfCardsInViewMobile: PropTypes.number
};

export default RelatedStoryWidget;
